export default __webpack_public_path__ + "static/media/sound.8d14102f.mp3";